<template>
    <div class="home-div">
        <SideBar />

        <div class="timeline-wrap">
            <!-- 新增标题区域 - 两列布局 -->
            <div class="timeline-header">
                <div class="header-title-cn">遊記時間線・踏足過的地方</div>
                <div class="header-subtitle">Travel Timeline</div>
            </div>

            <div class="timeline-row" v-for="(row, rowIdx) in timelineRows" :key="rowIdx">
                <div class="timeline-card" v-for="(item, colIdx) in row" :key="item.id">
                    <!-- 偶数行(正常顺序)→ 左侧实线 -->
                    <div v-if="rowIdx % 2 === 0 && colIdx !== 0" class="line line-left-dashed"></div>

                    <!-- 奇数行(反转) → 右侧虚线 -->
                    <div v-if="rowIdx % 2 === 1 && colIdx !== row.length - 1" class="line line-right-dashed"></div>

                    <!-- 偶数行 最后一列 + 是最后一行 → 右下拐角实线 -->
                    <template
                        v-if="rowIdx % 2 === 0 && colIdx === row.length - 1 && rowIdx !== timelineRows.length - 1">
                        <div class="bend bend-right-solid">
                            <div class="dot"></div>
                        </div>
                    </template>

                    <!-- 偶数行 第一列 + 非第一行 → 左上角虚线 -->
                    <template v-if="rowIdx % 2 === 0 && colIdx === 0 && rowIdx !== 0">
                        <div class="bend bend-left-dashed"></div>
                    </template>

                    <!-- 奇数行 第一列 + 不是最后一行 → 左下实线 -->
                    <template v-if="rowIdx % 2 === 1 && colIdx === 0 && rowIdx !== timelineRows.length - 1">
                        <div class="bend bend-left-solid">
                            <div class="dot"></div>
                        </div>
                    </template>

                    <!-- 奇数行 最后一列 + 是最后一行 → 右上拐角虚线 -->
                    <template v-if="rowIdx % 2 === 1 && colIdx === timelineRows[0].length - 1">
                        <div class="bend bend-right-dashed"></div>
                    </template>

                    <!-- 卡片内容 - 增加图片悬浮动画和城市标签 -->
                    <div class="card-cover">
                        <img :src="baseFileUrl + item.travelImg || defaultCover" alt="" class="cover-img"
                            @click="goToDetail(item.id)" />
                        <span class="card-index">{{ item.index }}</span>
                        <!-- 新增：城市标签，鼠标悬浮时旋转出现 -->
                        <div class="city-tag" v-if="item.city">
                            {{ getLastPart(item.travelTitle) }}
                        </div>
                    </div>
                    <div class="card-info">
                        <h3 class="card-title">{{ item.travelTitle }}</h3>
                        <div class="card-meta">
                            <span>{{ item.travelTime }}</span>
                            <span>{{ item.travelTemp }}°C</span>
                        </div>
                    </div>
                    <div v-if="rowIdx % 2 === 0 && colIdx < row.length - 1" class="line line-right-solid">
                        <div class="dot"></div>
                    </div>
                    <div v-if="rowIdx % 2 === 1 && colIdx > 0" class="line line-left-solid">
                        <div class="dot"></div>
                    </div>
                </div>
            </div>
        </div>

        <BottomTip />
    </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import { getTravelList } from '@/api/travels.js';
import config from '@/utils/Config';
export default {
    name: 'Travels',
    components: { SideBar, BottomTip },
    data() {
        return {
            baseFileUrl: config.BASE_FILE_URL,
            travelList: [],
            defaultCover: 'https://cn.bing.com/th?id=OHR.BadSunset_ZH-CN9050997938_UHD.jpg'
        };
    },
    computed: {
        sortedList() {
            const sorted = [...this.travelList]
                .sort((a, b) => new Date(b.sortDate) - new Date(a.sortDate));
            const total = sorted.length;
            return sorted.map((item, idx) => ({ ...item, index: total - idx }));
        },
        timelineRows() {
            // 动态计算列数
            let ROW_COL = 5;
            if (typeof window !== 'undefined') {
                const width = window.innerWidth;
                if (width < 640) ROW_COL = 2;
                else if (width < 1024) ROW_COL = 3;
                else if (width < 1280) ROW_COL = 4;
                else ROW_COL = 5;
            }

            // 先将数据按行分组（正常顺序）
            const rows = [];
            for (let i = 0; i < this.sortedList.length; i += ROW_COL) {
                rows.push(this.sortedList.slice(i, i + ROW_COL));
            }

            // 蛇形重排行内顺序：偶数行（索引0,2,4...）保持原序，奇数行反转
            return rows.map((row, idx) => {
                if (idx % 2 === 1) {
                    return [...row].reverse();
                }
                return row;
            });
        }
    },
    methods: {
        async getTravelListFromApi() {
            try {
                const response = await getTravelList();
                if (response && response.data) {
                    this.travelList = response.data;
                }
            } catch (error) {
                console.error('获取游记列表失败:', error);
            }
        },
        goToDetail(id) {
            this.$router.push({ path: "/travel-detail", query: { id: id } });
        },
        getLastPart(str) {
            if (!str) return '';
            const parts = str.split('|');
            const lastPart = parts[parts.length - 1].trim();
            return lastPart;
        }

    },
    mounted() {
        window.addEventListener('resize', () => {
            this.$forceUpdate();
        });
        this.getTravelListFromApi();
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.$forceUpdate();
        });
    }
};
</script>

<style scoped>
.home-div {
    width: 100%;
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.timeline-wrap {
    /* padding: 10px 20px; */
    max-width: 1200px;
    margin: 80px auto;
    min-height: calc(100vh - 200px);
}

/* 标题样式 - 两列布局 */
.timeline-header {
    diaplay: flex;
    fldex-direction: column;
    align-items: center;
    padding-left: 20px;
    margin-bottom: 60px;
    border-left: 4px solid #d4a574;
}

.header-title-cn {
    font-size: 28px;
    font-weight: 700;
    color: #2c3e50;
    letter-spacing: 2px;
    line-height: 1.2;
    margin-bottom: 6px;
    background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
    background-size: 400% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: gradientMove 8s ease-in-out infinite;
}

@keyframes gradientMove {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

.header-subtitle {
    font-size: 13px;
    font-weight: 400;
    color: var(--font-color-6);
    letter-spacing: 3px;
    text-transform: uppercase;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .timeline-header {
        gap: 15px;
        margin-bottom: 40px;
    }

    .header-bar {
        font-size: 48px;
        letter-spacing: -2px;
    }

    .header-title-cn {
        font-size: 22px;
    }

    .header-subtitle {
        font-size: 11px;
        letter-spacing: 2px;
    }
}

.timeline-row {
    display: flex;
    position: relative;
}

.timeline-card {
    width: 250px;
    flex-shrink: 0;
    /* 添加这行，防止被压缩 */
    flex-grow: 0;
    /* 添加这行，防止被拉伸 */
    border-radius: 8px;
    position: relative;
    height: 150px;
    padding: 0 25px;
    box-sizing: border-box;
}

@media (max-width: 768px) {
    .timeline-card {
        width: 180px !important;
    }
}

/* 统一线条基础样式 */
.line,
.bend {
    position: absolute;
    top: 45px;
    z-index: 2;
}

/* 奇数行，左实右虚 */
.line-left-solid {
    left: 0;
    width: 25px;
    border-top: 1.5px solid #f5f4f4;
}

.line-left-solid .dot {
    top: -5.5px;
    right: 1px;
    transform: rotate(45deg);
    border-radius: 0;
}

.line-right-dashed {
    right: 0;
    width: 25px;
    border-top: 1.5px dashed #f5f4f4;
}

/* 偶数行 右侧水平实线 */
.line-right-solid {
    right: 0;
    width: 25px;
    border-top: 1.5px solid #f5f4f4;
}

.line-right-solid .dot {
    top: -5.5px;
    left: 1px;
    /* 原来是 right，改为 left */
    transform: rotate(-135deg);
    /* 或者 -225deg */
    border-radius: 0;
}

/* .line-right-solid::after {
    content: '←';
    position: absolute;
    left: -8px;
    top: -1px;
    transform: translateY(-50%);
    color: #f5f4f4;
    font-size: 14px;
} */

/* 奇数行 左侧水平虚线 */
.line-left-dashed {
    left: 0;
    width: 25px;
    border-top: 1.5px dashed #f5f4f4;
}

/* ========== 右下拐角（偶数行最后一列） ========== */
.bend-right-solid {
    right: -0.5px;
    width: 25px;
    height: 75px;
    border-top: 1.5px solid #f5f4f4;
    border-right: 1.5px solid #f5f4f4;
    border-top-right-radius: 8px;
}

.bend-right-dashed {
    top: -30px;
    right: -0.5px;
    width: 25px;
    height: 75px;
    border-bottom: 1.5px dashed #f5f4f4;
    border-right: 1.5px dashed #f5f4f4;
    border-bottom-right-radius: 8px;
}

/* ========== 左下拐角（奇数行第一列） ========== */
.bend-left-solid {
    left: -0.5px;
    width: 25px;
    height: 75px;
    border-top: 1.5px solid #f5f4f4;
    border-left: 1.5px solid #f5f4f4;
    border-top-left-radius: 8px;
}

.bend-left-solid .dot {
    top: -5.5px;
    right: 1px;
    transform: rotate(45deg);
    border-radius: 0;
}

.bend-left-dashed {
    top: -30px;
    left: -0.5px;
    width: 25px;
    height: 75px;
    border-bottom: 1.5px dashed #f5f4f4;
    border-left: 1.5px dashed #f5f4f4;
    border-bottom-left-radius: 8px;
}

.bend-left-dashed .dot {
    top: -5px;
    right: 13px;
    transform: rotate(-135deg);
}

/* 端点箭头 */
.dot {
    position: absolute;
    width: 10px;
    height: 10px;
    border-top: 1.5px solid #f5f4f4;
    border-right: 1.5px solid #f5f4f4;
}

.bend-right-solid .dot {
    top: -5px;
    right: 13px;
    transform: rotate(-135deg);
}

/* 卡片内容样式 */
.card-cover {
    height: 90px;
    overflow: hidden;
    position: relative;
    border-radius: 8px;
    cursor: pointer;
    box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
}

/* 图片悬浮动画效果 */
.cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease-out, filter 0.3s ease;
}

.card-cover:hover .cover-img {
    transform: scale(1.08);
    filter: brightness(1.05) contrast(1.02);
}

/* 悬浮时添加一个轻微的遮罩层效果 */
.card-cover::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.card-cover:hover::after {
    opacity: 1;
}

/* 城市标签样式 - 白色背景，从右下逆时针旋转出现 */
.city-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    background: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #d4a574;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(2px);
    z-index: 3;
    letter-spacing: 0.5px;
    white-space: nowrap;
    max-width: calc(100% - 20px);
    overflow: hidden;
    text-overflow: ellipsis;

    /* 初始隐藏：从右下角缩小并旋转-90度 */
    opacity: 0;
    transform: scale(0.6) translate(8px, 8px) rotate(-90deg);
    transform-origin: bottom right;
    transition: all 0.35s cubic-bezier(0.34, 1.2, 0.64, 1);
    pointer-events: none;
}

/* 鼠标悬浮在卡片封面时，标签旋转出现 */
.card-cover:hover .city-tag {
    opacity: 1;
    transform: scale(1) translate(0, 0) rotate(0deg);
}

.card-index {
    position: absolute;
    right: 8px;
    bottom: 8px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.7);
    z-index: 2;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.card-info {
    padding: 8px 0 0;
}

.card-title {
    margin: 0 0 4px;
    font-size: 16px;
    color: var(--font-color-5);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.card-meta {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    color: var(--font-color-5);
    height: 25px;
    line-height: 25px;
}
</style>